import React, {Fragment} from 'react';
import { Route } from 'react-router-dom';
import './MainWindow.scss';

import Header from './Header';
import Dashboard from '../Dashboard';
import Sensor from '../Sensor';
import CommunitySensors from "../CommunitySensors";
import FieldGroups from "../FieldGroups";
import UserDetails from "../UserDetails";
import ManageUsers from "../ManageUsers";
import Notifications from "../Notifications";
import QrCodeGenerator from "../QrCodeGenerator";
import QrCodeGeneratorWhite from "../QrCodeGeneratorWhite";
import QrCodeGeneratorNoBackground from "../QrCodeGeneratorNoBackground";
import {isCompanyAdmin, isCompanyUser, isCustomer, isDistributorAdmin, isSuperAdmin} from "../../helpers/helpers";
import Companies from "../Companies";
import QrCodeGeneratorMultiple from "../QrCodeGeneratorMultiple";
import WeatherStations from "../WeatherStations";
import WeatherReports from "../WeatherReports";
import AlertRules from "../AlertRules/AlertRules";
import SensorReports from "../SensorReports/SensorReports";
import CalibrationValues from "../CalibrationValues/CalibrationValues";
import WarmHoursManagement from "../HoursManagement/WarmHoursManagement";
import ColdHoursManagement from "../HoursManagement/ColdHoursManagement";
import DrainStations from "../DrainStations/DrainStations";
import {useSelector} from "react-redux";
import AgronetUsersReport from "../AgronetUsersReport/AgronetUsersReport";
import GateSwitchers from "../GateSwitchers/GateSwitchers";
import StationStatus from "../StationStatus/StationStatus";
import DirectNotifications from "../DirectNotifications/DirectNotifications";
import UserNotices from "../UserNotices/UserNotices";
import UserNoticeEditor from "../UserNotices/UserNoticeEditor";
import SensorGroups from "../SensorGroups/SensorGroups";
import SensorValidation from "../SensorValidation/SensorValidation";
import CommunityMapHistory from "../CommunityMapHistory/CommunityMapHistory";
import CommunitySensorHistory from "../CommunitySensorHistory/CommunitySensorHistory";
import SensorGroupReports from "../SensorGroupReports/SensorGroupReports";
import DbPerformance from "../DbPerformance/DbPerformance";

const selector = state => {
    const { language,  modalState} = state;
    return {
        t: language.translator,
        modalState: modalState
    }
};

const MainWindow = () => {
    const { t, modalState} = useSelector(selector)

    return (
        <div className='mainWindow' >
            {!modalState.isTabletOrMobile && (
                <Header />
            )}
            <div className='contentContainer'>
                <Route exact path='/sensor_validation' component={SensorValidation}/>
                {isSuperAdmin() &&
                    <Route exact path='/temperature_map_history' component={CommunityMapHistory}/>
                }
                {isSuperAdmin() &&
                    <Route exact path='/community_sensor/:sensorId' component={CommunitySensorHistory}/>
                }
                <Route
                    exact path='/'
                    render={(props) =>
                        <Dashboard
                            {...props}
                        />
                    }
                />
                <Route
                    exact path='/sensor'
                    render={(props) =>
                        <Sensor
                            {...props}
                        />
                    }
                />
                {isSuperAdmin() &&
                    <Route
                        exact path='/sensor_groups'
                        render={props =>
                            <SensorGroups
                                {...props}
                            />
                        }
                    />
                }
                {(isSuperAdmin() || isCompanyAdmin() || isDistributorAdmin() || isCustomer()) &&
                    <Route
                        exact path='/weather_stations'
                        render={(props) =>
                            <WeatherStations
                                {...props}
                            />
                        }
                    />
                }
                {isSuperAdmin() &&
                    <Route
                        exact path='/station_status'
                        render={(props) =>
                            <StationStatus
                                {...props}
                            />
                        }
                    />
                }
                {(isSuperAdmin() || isCompanyAdmin() || isDistributorAdmin() || isCustomer()) &&
                    <Route
                        exact path='/drain_stations'
                        render={(props) =>
                            <DrainStations
                                {...props}
                            />
                        }
                    />
                }
                {(isSuperAdmin() || isCompanyAdmin() || isDistributorAdmin() || isCustomer()) &&
                    <Route
                        exact path='/gate_switchers'
                        render={(props) =>
                            <GateSwitchers
                                {...props}
                            />
                        }
                    />
                }
                {(isSuperAdmin() || isCompanyAdmin() || isDistributorAdmin() || isCustomer()) &&
                    <Route
                        exact path='/weather_reports'
                        render={(props) =>
                            <WeatherReports
                                {...props}
                            />
                        }
                    />
                }
                {(isSuperAdmin() || isCompanyAdmin() || isDistributorAdmin() || isCustomer() || isCompanyUser()) &&
                    <Route
                        exact path='/sensor_reports*'
                        render={(props) =>
                            <SensorReports
                                {...props}
                            />
                        }
                    />
                }
                {isSuperAdmin() &&
                    <Route exact path='/db_performance' component={DbPerformance}/>
                }
                {isSuperAdmin() &&
                    <Route
                        exact path='/sensor_group_reports'
                        render={props =>
                            <SensorGroupReports
                                {...props}
                            />
                        }
                    />
                }
                <Route
                    exact path='/alert_rules'
                    render={(props) =>
                        <AlertRules
                            {...props}
                        />
                    }
                />
                <Route
                    exact path='/calibration_values'
                    render={(props) =>
                        <CalibrationValues
                            {...props}
                        />
                    }
                />
                <Route
                    exact path='/warm_hours'
                    render={(props) =>
                        <WarmHoursManagement
                            {...props}
                        />
                    }
                />
                <Route
                    exact path='/cold_hours'
                    render={(props) =>
                        <ColdHoursManagement
                            {...props}
                        />
                    }
                />
                {(!process.env.REACT_APP_CLIENT_VERSION || process.env.REACT_APP_CLIENT_VERSION === 'no') && (
                    <Fragment>
                        {!isDistributorAdmin() &&
                            <Route
                                exact path='/community_sensors'
                                render={(props) =>
                                    <CommunitySensors
                                        {...props}
                                    />
                                }
                            />
                        }
                        <Route
                            exact path='/field_groups'
                            render={(props) =>
                                <FieldGroups
                                    {...props}
                                />
                            }
                        />
                        <Route
                            exact path='/user_details'
                            render={(props) =>
                                <UserDetails
                                    {...props}
                                />
                            }
                        />
                        {(isSuperAdmin() || isCompanyAdmin() || isDistributorAdmin()) &&
                            <Route
                                exact path='/manage_users'
                                render={(props) =>
                                    <ManageUsers
                                        {...props}
                                    />
                                }
                            />
                        }
                        {isSuperAdmin() &&
                            <Route
                                exact path='/manage_all_users'
                                render={(props) =>
                                    <ManageUsers
                                        {...props}
                                        superAdmin
                                    />
                                }
                            />
                        }
                        {(isSuperAdmin() || isDistributorAdmin()) && (
                            <Route
                                exact path='/users_access_table'
                                render={(props) =>
                                    <AgronetUsersReport
                                        {...props}
                                        superAdmin
                                    />
                                }
                            />
                        )}
                        {isSuperAdmin() &&
                            <Route
                                exact path='/direct_notifications'
                                render={(props) =>
                                    <DirectNotifications
                                        {...props}
                                    />
                                }
                            />
                        }
                        {isSuperAdmin() &&
                            <Route
                                exact path='/user_messages'
                                render={(props) =>
                                    <UserNotices
                                        {...props}
                                    />
                                }
                            />
                        }
                        {isSuperAdmin() &&
                            <Route
                                exact path='/user_messages/new'
                                render={(props) =>
                                    <UserNoticeEditor
                                        {...props}
                                    />
                                }
                            />
                        }
                        <Route
                            exact path='/notifications'
                            render={(props) =>
                                <Notifications
                                    {...props}
                                />
                            }
                        />
                        {isSuperAdmin() &&
                            <Route
                                exact path='/companies'
                                render={(props) =>
                                    <Companies
                                        {...props}
                                    />
                                }
                            />
                        }
                        {(isSuperAdmin() || isCompanyAdmin()) &&
                            <Route
                                exact path='/qr_code_generator'
                                render={(props) =>
                                    <QrCodeGenerator
                                        {...props}
                                    />
                                }
                            />
                        }
                        {(isSuperAdmin() || isCompanyAdmin()) &&
                            <Route
                                exact path='/qr_code_generator_multiple'
                                render={(props) =>
                                    <QrCodeGeneratorMultiple
                                        {...props}
                                    />
                                }
                            />
                        }
                        {(isSuperAdmin() || isCompanyAdmin()) &&
                            <Route
                                exact path='/qr_code_generator_black'
                                render={(props) =>
                                    <QrCodeGeneratorWhite
                                        {...props}
                                    />
                                }
                            />
                        }
                        {(isSuperAdmin() || isCompanyAdmin()) &&
                            <Route
                                exact path='/qr_code_generator_no_background'
                                render={(props) =>
                                    <QrCodeGeneratorNoBackground
                                        {...props}
                                    />
                                }
                            />
                        }
                    </Fragment>
                )}
            </div>
        </div>
    );

};

export default MainWindow;
